import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const LOADING_ANIMATION = (
  <>
    <div className="centerload">
      <div className="load-dot"/>
      <div className="load-dot"/>
      <div className="load-dot"/>
      <div className="load-dot"/>
      <div className="load-dot"/>
    </div>
  </>
);

const ActionButton = ({text, width = 'full', isLoading = false, onClick}) => {
  const content = isLoading ? LOADING_ANIMATION : text;
  return (
    <button
      type="button"
      className={classnames('btn', width, 'primary')}
      onClick={onClick}
    >
      {content}
    </button>
  );
};

ActionButton.propTypes = {
  text: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

export default ActionButton;
